/** @jsxRuntime classic */
/** @jsx jsx */

import { jsx } from 'theme-ui'
import { Fragment } from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css'

import { GatsbyImgStyled, StaticImageFigureStyled, StaticImagePlaceholderStyled } from './styles'
import { MediaProps } from './types'
import HtmlVideo from './../../atoms/HtmlVideo'
import Image from './../../atoms/Image'

const MediaItem: React.FC<MediaProps> = ({ media, objectFit }) => {
  const { image, video } = media

  return (
    <Fragment>
      {image ? (
        image.childImageSharp ? (
          <GatsbyImgStyled>
            <Image fluid={image.childImageSharp} alt={image.alt} objectFit="contain" width={image.width} height={image.width} />
          </GatsbyImgStyled>
        ) : (
          <StaticImageFigureStyled>
            <LazyLoadImage
              src={image.publicURL}
              placeholder={<StaticImagePlaceholderStyled />}
              alt={image.alt}
              width={image.width}
              height={image.height}
              effect="blur"
            />
          </StaticImageFigureStyled>
        )
      ) : video ? (
        <HtmlVideo videoSrc={video.url} />
      ) : (
        ''
      )}
    </Fragment>
  )
}

export default MediaItem
